import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/roles',
    name: 'RoleIndex',
    component: {
      name: 'AdminRole',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'role',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminRoleIndex',
        component: () => import('../views/RoleIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminRoleNew',
        component: () => import('../views/RoleInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminRoleIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminRoleShow',
        component: () => import('../views/RoleShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminRoleIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminRoleDetails',
            component: () => import('../views/RoleDetails.vue'),
            meta: {
              backRoute: { name: 'AdminRoleIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminRoleEdit',
            component: () => import('../views/RoleInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminRoleDetails' },
            },
          },
          {
            path: 'rights/edit',
            name: 'AdminRoleRightsEdit',
            component: () => import('../views/RoleRightsInput.vue'),
            meta: {
              action: 'edit',
              customName: 'views.role.edit_rights',
              backRoute: { name: 'AdminRoleDetails' },
            },
          },
          {
            path: 'dashboard_pages',
            name: 'DashboardPage',
            component: {
              name: 'AdminDashboardPage',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminRoleIndex' },
              resource: 'dashboard_page',
            },
            children: [
              {
                path: '',
                name: 'AdminDashboardPage',
                component: () => import('../views/dashboardPage/RoleDashboardPages.vue'),
                meta: {
                  backRoute: { name: 'AdminRoleIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminDashboardPageNew',
                component: () => import('../views/dashboardPage/DashboardPageInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminDashboardPage' },
                },
              },
              {
                path: ':dashboardPageId(\\d+)',
                name: 'AdminDashboardPageShow',
                component: () => import('../views/dashboardPage/DashboardPageShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminDashboardPage',
                  },
                  tArgs: route => ({ name: route?.params?.dashboardPageId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminDashboardPageDetails',
                    component: () => import('../views/dashboardPage/DashboardPageDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminDashboardPage' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminDashboardPageEdit',
                    component: () => import('../views/dashboardPage/DashboardPageInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminDashboardPageDetails' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));